import * as React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { Button, Grid } from '@material-ui/core';
import { Typography } from '@material-ui/core';
import { useHistory } from 'react-router-dom';

interface Props {

};

const AdminHome: React.FC<Props> = (prop: Props) => {
    const history = useHistory();

    const useStyles = makeStyles((theme: Theme) =>
        createStyles({
        spinner: {
            marginLeft: 5,
            color: 'primary',
        },
        formControl: {
            margin: theme.spacing(1),
            minWidth: 120,
        },
        selectEmpty: {
            marginTop: theme.spacing(2)
        },
        header: {
            marginBottom: theme.spacing(1),
            marginTop: theme.spacing(1)
        }
        }),
    );
    const classes = useStyles();


    const NavTo = (e: any, path: string) => {
        history.push('/admin/' + path);
    }

return (
    <Grid container direction="column" justify="flex-start" alignItems="stretch" spacing={1}>
          <Grid item><Typography variant="h6" className={classes.header}></Typography></Grid>
          <Grid item><Button variant="outlined" color="primary" onClick={(e) => NavTo(e, 'policy')}>Edit Policy Defaults</Button></Grid>
    </Grid>
)
}

export default AdminHome;